import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListImage(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListImage',
		componentId: uuidv4(),
		props: Object.assign({ width: 96 }, props),
		childrenComponents,
	};
}
